import * as type from '../../constants';

const initialState = {
  announcementList: null,
  announcementDetails: null,
  loading: false,
  error: null,

  updateLoader: false
}

export function announcementReducer(state = initialState, action) {
  switch (action.type) {
    case type.GET_ANNOUNCEMENT_LIST:
      return {
        ...state,
        loading: true,
      }
    case type.GET_ANNOUNCEMENT_LIST_SUCCESS:
      return {
        ...state,
        announcementList: action.response,
        loading: false,
        error: null
      }

    case type.GET_ANNOUNCEMENT_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        announcementList: null,
        error: action.message,
      }


    case type.GET_ANNOUNCEMENT_DETAILS:
      return {
        ...state,
        loading: true,
      }
    case type.GET_ANNOUNCEMENT_DETAILS_SUCCESS:
      return {
        ...state,
        announcementDetails: action.response,
        loading: false,
        error: null
      }

    case type.GET_ANNOUNCEMENT_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        announcementDetails: null,
        error: action.message,
      }
  


    case type.ADD_ANNOUNCEMENT:
      return {
        ...state,
        updateLoader: true,
      }
    case type.ADD_ANNOUNCEMENT_SUCCESS:
      return {
        ...state,
        updateLoader: false,
      }
    case type.ADD_ANNOUNCEMENT_FAILURE:
      return {
        ...state,
        updateLoader: false,
      }
      
    case type.UPDATE_ANNOUNCEMENT:
      return {
        ...state,
        updateLoader: true,
      }
    case type.UPDATE_ANNOUNCEMENT_SUCCESS:
      return {
        ...state,
        updateLoader: false,
      }
    case type.UPDATE_ANNOUNCEMENT_FAILURE:
      return {
        ...state,
        updateLoader: false,
      }
          
    
    case type.DELETE_ANNOUNCEMENT:
      return {
        ...state,
        updateLoader: true,
      }
    case type.DELETE_ANNOUNCEMENT_SUCCESS:
      return {
        ...state,
        updateLoader: false,
      }
    case type.DELETE_ANNOUNCEMENT_FAILURE:
      return {
        ...state,
        updateLoader: false,
      }

    default:
      return state
  }
}
